import React from 'react'

import { pluralize_noun } from '@newswebsiteapp/shared/react/utils/pluralize'

export function Packages({
  dataFromServer,
  state,
  setModalOpen,
  packageForm_updateState,
  packageForm_handlePackageQuantity,
  packageForm_handlePurchaseNow,
  greenpay,
}) {
  // dataFromServer.conference_packages.map((conference_package) => {
  //   console.log('conference_packages', conference_package, state.selectedPackages.hasOwnProperty(conference_package.id) ? state.selectedPackages[conference_package.id] : null)
  // })

  return (
    <div className='container-fluid segment full-max-width-down-sm pb-2 mb-2'>
      <div className='col-12 my-4 pb-2 flex-first'>
        <h4 className='p-2 conference-form-header text-center'>
          Tickets on Sale Now!
        </h4>
      </div>

      <div className='col-12 justify-content-center row px-md-5'>
        {dataFromServer.conference_packages.map((conference_package) => (
          <div
            key={conference_package.id}
            className='card m-1 col-xl-5 col-md-5 col-sm-12 col-xs-6 px-4 text-center'
          >
            <label
              className='conference-package-item'
              htmlFor={`package-${conference_package.id}`}
            >
              <h4 className='text-center text-break'>{conference_package.title}</h4>
              <p className='text-center text-break'>{conference_package.description}</p>
              {conference_package.is_live_ticket
                ? (
                  <p className='text-center text-break'>
                    {`This package includes ${conference_package.person_amount} ${pluralize_noun(conference_package.person_amount, 'ticket')}.`}
                  </p>
                )
                : (
                  <p className='text-center text-break'>
                    This is online only ticket
                  </p>
                )}
              <div className='page-item-price'>
                {conference_package.can_purchase
                  ? `$${conference_package.price_cents / 100}`
                  : 'SOLD OUT'}
              </div>

              {conference_package.checkout_payment_page_url
                ? (
                  <div className='mt-3 conference-package-amount-input'>
                    <a className='btn btn-warning btn-sm mx-auto' href={conference_package.checkout_payment_page_url} target='_blank' rel='noreferrer'>
                      PURCHASE NOW
                    </a>
                  </div>
                )
                : (
                  <div className='mt-3 conference-package-amount-input'>
                    <p>Ask admin to create payment pages for this package</p>
                  </div>
                )}

              {/*
              {conference_package.can_purchase && (
                <div className='mt-3 conference-package-amount-input'>
                  <p>Quantity:</p>
                  <QuantityInput
                    min={Object.prototype.hasOwnProperty.call(state.selectedPackages, conference_package.id) ? 0 : 1}
                    max={dataFromServer.conference.live_tickets_available}
                    value={Object.prototype.hasOwnProperty.call(state.selectedPackages, conference_package.id) ? state.selectedPackages[conference_package.id] : null}
                    onChange={(_event, newQuantity) =>
                      packageForm_handlePackageQuantity({
                        packageId: conference_package.id,
                        newQuantity,
                        packageForm_updateState,
                        dataFromServer,
                      })}
                  />
                </div>
              )}
              */}
            </label>
          </div>
        ))}
      </div>

      {/*
      <div className='col-md-12'>
        {state.purchaseNowButtonWasPressedAtLeastOnce &&
          state.errorMessage && (
            <AlertWithAutoFocus color='danger' size='lg' variant='solid'>
              {state.errorMessage}
            </AlertWithAutoFocus>
        )}
        <div className='form-group my-sm-0'>
          <div className='conference-form-field-wrapper text-left'>
            <FormControl
              error={
                state.purchaseNowButtonWasPressedAtLeastOnce &&
                !!state.errorMessage
              }
            >
              <FormLabel>Calculated price</FormLabel>
              <Input
                readOnly
                value={state.calculatedPriceCents / 100}
                placeholder='$0'
                slotProps={dollarInputFormatAdapter__slotProps}
              />
            </FormControl>
            <FormControl
              error={
                state.inRealLifeTicketsBought >
                dataFromServer.conference.live_tickets_available
              }
            >
              <FormLabel>Live tickets selected</FormLabel>
              <Input
                readOnly
                value={`${state.inRealLifeTicketsBought} live ${pluralize_noun(state.inRealLifeTicketsBought, 'ticket')} of ${dataFromServer.conference.live_tickets_available} available`}
                placeholder='0 live tickets of 0 available'
              />
            </FormControl>
          </div>
        </div>
        <div className='row mt-3'>
          <button
            className='btn btn-warning btn-sm mx-auto'
            onClick={() => packageForm_handlePurchaseNow({ packageForm_updateState, dataFromServer, setModalOpen })}
          >
            PURCHASE NOW
          </button>
        </div>
      </div>
      */}
    </div>
  )
}
